import axios from './index'
import url from './url'
// 引用fetch.js

function indexBanner (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/indexBanner`,
    { params: typeOne }
  )
}

function getOneType (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getFirstCategory`,
    {
            params: typeOne,
            headers:{
                Authorization: 'Bearer ' + localStorage.getItem('token')
            }
        }
  )
}

function getTwoType (typeTwo) {
  return axios.get(
    `${url.wz}/public/v1/getSecCategory`,
    { params: typeTwo }
  )
}

function getAllType (all) {
  return axios.get(
    `${url.wz}/public/v1/getCategory`,
    { params: all }
  )
}

function getDaohangType (all) {
  return axios.get(
    `${url.wz}/public/v1/daohang/getCategoryList`,
    { params: all }
  )
}

function getTravleBanner (id) {
  return axios.get(
    `${url.wz}/public/v1/banner`,
    { params: id }
  )
}
//新广告位模块接口
function getModuleAdvertising (id) {
  return axios.get(
    `${url.wz}/public/v1/getModuleAdvertising`,
    { params: id }
  )
}

function getTravleList (params) {
  return axios.post(
    `${url.wz}/public/v1/tour/lists`,
    params
  )
}

function getTravleDetail (params) {
  return axios.post(
    `${url.wz}/public/v1/tour/detail`,
    params
  )
}

function getTravleDetailRecommend (params) {
  return axios.post(
    `${url.wz}/public/v1/tour/detail_r`,
    params
  )
}

function getTravleDetailNav (params) {
  return axios.get(
    `${url.wz}/public/v1/tour/detail_n`,
    { params: params }
  )
}

function getTravleDetailJ (params) {
  return axios.post(
    `${url.wz}/public/v1/tour/detail_s`,
    params
  )
}

function getTravleDetailR (params) {
  return axios.post(
    `${url.wz}/public/v1/tour/detail_m`,
    params
  )
}

function Login (params) {
  return axios.post(
    `${url.wz}/public/v1/login`,
    params
  )
}

function sendRegSms (params) {
  return axios.post(
    `${url.wz}/public/v1/sendRegSms`,
    params
  )
}

function Register (params) {
  return axios.post(
    `${url.wz}/public/v1/register`,
    params
  )
}

function Adjacent (params) {
  return axios.get(
    `${url.wz}/public/v1/tour/adjacent`,
    { params: params }
  )
}

function SendForgetSms (params) {
  return axios.post(
    `${url.wz}/public/v1/sendForgetSms`,
    params
  )
}

function ForgetPassword (params) {
  return axios.post(
    `${url.wz}/public/v1/forgetPassword`,
    params
  )
}

// 效验验证码接口
function checkVerifyCode (params) {
  return axios.get(
    `${url.wz}/public/v1/checkVerifyCode`,
    { params: params }
  )
}

function getTuijianList (params) {
  return axios.get(
    `${url.wz}/public/v1/getTuijianList`,
    { params: params }
  )
}

function getAppcode (params) {
  return axios.get(
    `${url.wz}/public/v1/getAppcode`,
    { params: params }
  )
}

function searchCount (params) {
  return axios.get(
    `${url.wz}/public/v1/searchCount`,
    { params: params }
  )
}

function search (params) {
  return axios.get(
    `${url.wz}/public/v1/search`,
    { params: params }
  )
}

function getLoginQrcode (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/getLoginQrcode`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

function checkAjaxlogin (typeOne) {
  return axios.get(
    `${url.wz}/public/v1/checkAjaxlogin`,
    {
      params: typeOne,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token'),
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }
  )
}

function getClientCity (params) {
  return axios.get(
    `${url.wz}/public/v1/getClientCity`,
    { params: params }
  )
}

export {
  indexBanner,
  getOneType,
  getTwoType,
  getAllType,
  getModuleAdvertising,
  getTravleBanner,
  getTravleList,
  getTravleDetail,
  getTravleDetailRecommend,
  getTravleDetailNav,
  getTravleDetailJ,
  getTravleDetailR,
  Login,
  sendRegSms,
  Register,
  Adjacent,
  SendForgetSms,
  ForgetPassword,
  checkVerifyCode,
  getTuijianList,
  getDaohangType,
  getAppcode,
  searchCount,
  search,
  getLoginQrcode,
  checkAjaxlogin,
  getClientCity
}



// WEBPACK FOOTER //
// ./src/axios/api.js